
export default (to, from, next) => {
  document.title = to.meta.title || 'LendingWell'
  return next()
}
